module.exports = __webpack_public_path__ + "img/そもそも「相続」とは.bf1c7ec0.png";